"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMultiSelectValue = exports.getWidthValue = void 0;
const getWidthValue = (pixels) => {
    return pixels
        ? pixels + 'px'
        : '-moz-available; width: -webkit-fill-available; width: fill-available; width:100%';
};
exports.getWidthValue = getWidthValue;
const getMultiSelectValue = (options) => {
    const selectedOptionsText = options.reduce((selectedOptionsText, option) => {
        if (option.checked) {
            selectedOptionsText.push(option.text);
        }
        return selectedOptionsText;
    }, []);
    return selectedOptionsText.join(', ');
};
exports.getMultiSelectValue = getMultiSelectValue;
//# sourceMappingURL=utils.js.map